export default __webpack_public_path__ + "static/media/distress-of-rent.e3954592.jpg";